export const automotiveTransportMaintenanceConst = {
  path: "/single-programs/automotive-transport-maintenance",
  title: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – ЭКСПЛУАТАЦИЯ АВТОМОБИЛЬНОГО ТРАНСПОРТА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения</strong>: очно или дистанционно
      </p>
      <p>
        <strong>Форма связи:</strong> Получить консультацию приемной комиссии
      </p>
      <h2>Транспорт будущего — в руках инженеров</h2>
      <p>
        Эта программа охватывает все аспекты управления, эксплуатации и технического обслуживания автотранспортных средств. Студенты изучают
        логистику, диагностику, обслуживание, а также современные технологии в автомобильной отрасли.
      </p>
      <p>
        Образование ориентировано на подготовку профессионалов, которые обеспечивают безопасность, эффективность и устойчивость транспортных
        систем.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Устройство и эксплуатация автотранспорта</li>
        <li>Логистика перевозок</li>
        <li>Диагностика и техническое обслуживание</li>
        <li>Транспортные системы и их управление</li>
        <li>Организация работы автотранспортных предприятий</li>
        <li>Информационные технологии в логистике</li>
        <li>Экология и безопасность движения</li>
        <li>Законодательные и нормативные требования ЕС</li>
      </ul>
      <p>В рамках программы предусмотрены стажировки, работа с симуляторами, а также реальная практика в транспортных компаниях.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер по автотранспорту</li>
        <li>Специалист по логистике и транспортной аналитике</li>
        <li>Консультант по техническому обслуживанию</li>
        <li>Руководитель автопарка</li>
        <li>Специалист по диагностике и ремонту</li>
        <li>Менеджер по автосервису и обслуживанию</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€40,000 до €75,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Международно признанный диплом</li>
        <li>Дистанционная или очная форма обучения</li>
        <li>Возможность учиться на русском или английском языке</li>
        <li>Преподаватели-практики с отраслевым опытом</li>
        <li>Доступ к современным лабораториям и симуляторам</li>
        <li>Поддержка на всех этапах от приёмной комиссии</li>
      </ul>
      <p>Инженеры, которые держат транспорт в движении</p>
      <p>
        Наши выпускники становятся специалистами, которые отвечают за надёжную работу автопарков, оптимизацию логистики и внедрение новых
        технологий в автомобильной сфере.
      </p>
      <br />
      <p className="padding-left">«Транспорт — это артерии экономики. Мы обучаем тех, кто умеет их грамотно обслуживать и развивать.»</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам подобрать подходящую программу, собрать документы и пройти весь процесс поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Транспорт будущего — в руках инженеров
    Эта программа охватывает все аспекты управления, эксплуатации и технического обслуживания автотранспортных средств. Студенты изучают логистику, диагностику, обслуживание, а также современные технологии в автомобильной отрасли.
    Образование ориентировано на подготовку профессионалов, которые обеспечивают безопасность, эффективность и устойчивость транспортных систем.
    Что вы будете изучать?
    • Устройство и эксплуатация автотранспорта
    • Логистика перевозок
    • Диагностика и техническое обслуживание
    • Транспортные системы и их управление
    • Организация работы автотранспортных предприятий
    • Информационные технологии в логистике
    • Экология и безопасность движения
    • Законодательные и нормативные требования ЕС
    В рамках программы предусмотрены стажировки, работа с симуляторами, а также реальная практика в транспортных компаниях.
    Кем можно работать после окончания?
    • Инженер по автотранспорту
    • Специалист по логистике и транспортной аналитике
    • Консультант по техническому обслуживанию
    • Руководитель автопарка
    • Специалист по диагностике и ремонту
    • Менеджер по автосервису и обслуживанию
    Зарплата в Европе: от €40,000 до €75,000 в год
    Почему выбирают нас?
    • Международно признанный диплом
    • Дистанционная или очная форма обучения
    • Возможность учиться на русском или английском языке
    • Преподаватели-практики с отраслевым опытом
    • Доступ к современным лабораториям и симуляторам
    • Поддержка на всех этапах от приёмной комиссии
    Инженеры, которые держат транспорт в движении
    Наши выпускники становятся специалистами, которые отвечают за надёжную работу автопарков, оптимизацию логистики и внедрение новых технологий в автомобильной сфере.
    «Транспорт — это артерии экономики. Мы обучаем тех, кто умеет их грамотно обслуживать и развивать.»

    Как поступить?
    Приёмная комиссия поможет вам подобрать подходящую программу, собрать документы и пройти весь процесс поступления.
`,
};
